import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
// Limitless Imports
import { useAppConfig } from "@limitless/common/hooks";
import {
    useExpertPendingFeeAllocationContext,
    useExpertAnnouncementsContext,
    useExpertProfileContext
} from "@limitless/expert";
import { AnnouncementDialog, formatCurrency, formatPoints } from "@limitless/portal";
import { formatRating } from "@limitless/common/utils";
import ExpertRemoteContent from "../../expert-remote-content/ExpertRemoteContent";
import { POLICY_PAYMENTS_ACCESS } from "@limitless/portal/utils";
import HeaderMetric from "./header-metric/HeaderMetric";

const ExpertHeader = ({ navigate }) => {
    const { profile, canUserAccess } = useExpertProfileContext();
    const { pendingFeeAllocation } = useExpertPendingFeeAllocationContext();
    const { getFeatureSwitches } = useAppConfig();
    const { pendingMessageDetail } = getFeatureSwitches();

    const hasPaymentAccessForHeaderSection = canUserAccess(POLICY_PAYMENTS_ACCESS);
    const history = useHistory();

    const { getHighPriorityAnnouncements, saveHighPriorityAnnouncement, acknowledgeAnnouncement } =
        useExpertAnnouncementsContext();

    const highPriorityAnnouncements = getHighPriorityAnnouncements();

    const renderPoints = () => {
        const { points } = profile;

        return formatPoints(points);
    };

    const renderBalance = () => {
        const { balance, balanceCurrency, balanceCurrencySymbol, country, language, userName } = profile;

        return formatCurrency(balance, { balanceCurrency, balanceCurrencySymbol, country, language, userName });
    };

    const renderRating = () => {
        const { custRating } = profile;

        return formatRating(custRating);
    };

    const handleAnnouncementDismiss = (announcement, callback) => {
        acknowledgeAnnouncement(announcement, () => {
            //this clear the current dialog loading state
            callback();
        });
    };

    return (
        <>
            {highPriorityAnnouncements.length !== 0 && (
                <AnnouncementDialog
                    announcements={highPriorityAnnouncements}
                    onSaveAnnouncement={saveHighPriorityAnnouncement}
                    onAnnouncementDismiss={handleAnnouncementDismiss}
                    remoteContentComponent={ExpertRemoteContent}
                />
            )}

            {hasPaymentAccessForHeaderSection && (
                <>
                    <HeaderMetric
                        id="profileMetricPendingText"
                        text="pending"
                        metric={pendingFeeAllocation}
                        onClick={
                            pendingMessageDetail
                                ? () =>
                                      history.push({
                                          pathname: "/payment",
                                          state: true
                                      })
                                : null
                        }
                        visible={hasPaymentAccessForHeaderSection}
                    />
                    <HeaderMetric
                        id="profileMetricBalanceText"
                        text="balance"
                        metric={renderBalance()}
                        onClick={() => navigate("/payment")}
                        visible={hasPaymentAccessForHeaderSection}
                    />
                    <HeaderMetric
                        id="profileMetricPointsText"
                        text="points"
                        metric={renderPoints()}
                        onClick={() => navigate("/dashboard")}
                        visible={hasPaymentAccessForHeaderSection}
                    />
                </>
            )}
            <HeaderMetric
                id="profileMetricPendingText"
                text="rating"
                metric={renderRating()}
                onClick={() => {
                    if (hasPaymentAccessForHeaderSection) {
                        navigate("/dashboard/ratings");
                    }
                }}
                visible
            />
        </>
    );
};

ExpertHeader.propTypes = {
    navigate: PropTypes.func
};

export default ExpertHeader;
